export enum SiteType {
	venue = 'venue',
	artist = 'artist',
	company = 'company',
	admin = 'admin',
	/* Shared elements of venue sites. Dummy router, doesn't actually exist: */
	shared = 'shared',
}

